import React from "react";
import { useMyHrPostalCodes } from "my-hr/hooks";
import { OcFormEditorItemList } from "oc/components";
import { useOcFormEditorSelector } from "oc/hooks";

interface OcFormEditorZipSelectorProps {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  isNewAddress: boolean;
}

export const OcFormEditorZipSelector: React.FC<
  OcFormEditorZipSelectorProps
> = ({ name, label, value, onChange, error }) => {
  const { data: postalCodes } = useMyHrPostalCodes();
  const isZip = name === "zip" ? true : false;
  const {
    list,
    search,
    selectedItem,
    handleSearch,
    handleClearSearch,
    handleHasMore,
  } = useOcFormEditorSelector({
    value,
    list: postalCodes,
    selectName: !isZip,
    searchCode: name === "zip" ? true : false,
  });

  return (
    <OcFormEditorItemList
      search={search}
      onSearch={handleSearch}
      onChange={onChange}
      onClearSearch={handleClearSearch}
      list={list}
      onScroll={handleHasMore}
      value={selectedItem}
      label={label}
      name={name}
      error={!!error}
      showCode={isZip}
      showItem={true}
    />
  );
};

export default OcFormEditorZipSelector;
